module.exports = __webpack_public_path__ + "img/0017.c56db774.jpg";